<template>
    <div class="radio-check">
        <div class="check-true" :class="{'checked': value === 1 }" @click="changeValue(1)">
            <img :src="value == 1 ? checkIcon : checkDarkIcon" alt="">
        </div>
        <div class="check-false" :class="{'checked': value === 2 }" @click="changeValue(2)">
            <img :src="value == 2 ? xIcon : xDarkIcon" alt="">
        </div>
    </div>
</template>


<script>
export default {
    name: 'radio_true_false',
    props: {
        value: {
            default: 0
        }
    },
    data() {
        return {
            checkDarkIcon: require('@/assets/icons/check-dark.png'),
            checkIcon: require('@/assets/icons/check.png'),
            xDarkIcon: require('@/assets/icons/x-dark.png'),
            xIcon: require('@/assets/icons/x.png'),
        }
    },
    methods: {
        changeValue(value) {
            this.$emit('input', value)
        }
    }
}
</script>

<style scoped>
.radio-check>div {
    border: 2px solid #000;
    border-radius: 5px;
    margin-right: 20px;
    height: 40px;
    width: 40px;
    cursor: pointer;
}

.radio-check {
    display: flex;
}

.radio-check>div>img {
    height: 35px;
    width: 35px;
}
</style>